// recursively search for possible transition defined inside the component root
function locateNode(vnode) {
    return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
        ? locateNode(vnode.componentInstance._vnode)
        : vnode
}

function updateVisibility(el, shouldShow, important = false) {
    if (shouldShow) {
        el.style.setProperty('display', el.__vOriginalDisplay)
    } else {
        el.style.setProperty('display', 'none', important ? 'important' : undefined)
    }
}

export default {
    bind(el, { value, modifiers: { important } }, vnode) {
        vnode = locateNode(vnode)

        el.__vOriginalDisplay = el.style.display === 'none' ? '' : el.style.display

        updateVisibility(el, value, important)
    },

    update(el, { value, oldValue, modifiers: { important } }, vnode) {
        if (!value === !oldValue) {
            return
        }

        vnode = locateNode(vnode)

        updateVisibility(el, value, important)
    },

    unbind(
        el,
        binding,
        vnode,
        oldVnode,
        isDestroy
    ) {
        if (!isDestroy) {
            updateVisibility(el, true)
        }
    }
}